

import Vue from 'vue'
import Component from "vue-class-component";
import {namespace} from "vuex-class";
import {Prop} from "vue-property-decorator";

import {IAuthUserData, IAuthUserPermission} from "@/store/modules/authModule";
import {IOnOffHandlers} from "bonomo/dist";
import {EPermissionTargets} from "@/model/EPermissionTargets";
import {ILocker} from "@/model/Locker/lockerInterfaces";
import {IShortChannel, IShortServiceProvider} from "@/model/shortInterfaces";
import {IShortCommunity} from "@/model/Community/communityInterfaces";
import {PermissionHelper} from "@/helpers/PermissionHelper";
import {EUserPermissions} from "@/model/EUserPermissions";

  const authModule = namespace("authModule");
  const channelModule = namespace("channelModule");
  const communityModule = namespace("communityModule");
  const lockerModule = namespace("lockerModule");
  const permissionsModule = namespace("permissionsModule");
  const serviceProviderModule = namespace("serviceProviderModule");
  const userPermissionModule = namespace("userPermissionModule");

  @Component({
    name: 'UPDialog',
  })
  export default class UPDialog extends Vue {

    @Prop()
    user!: IAuthUserData;
    @Prop()
    userId!: number;

    @authModule.Getter('userData')
    authUser!: IAuthUserData;
    @channelModule.Getter('channels')
    channels!: IShortChannel[];
    @communityModule.Getter('communityList')
    communities!: IShortCommunity[];
    @lockerModule.Getter('lockers')
    lockers!: ILocker[];
    @permissionsModule.Getter('permissionTargets')
    permissionTargets!: string[];
    @serviceProviderModule.Getter('serviceProviders')
    serviceProviders!: IShortServiceProvider[];
    @userPermissionModule.Getter('errors')
    errors!: any;


    get permissionItems() {
      let ret: any[] = [];
      // note at this point we actually must have the authuser (if not, the button to pop this dialog would be disabled yet)
      const permissions: IAuthUserPermission[] = this.authUser.permissions || [];
      const isDeveloper = PermissionHelper.hasPermission(this.authUser, EUserPermissions.PERMISSION_DEVELOPER, 0);
      const canGiveThesePermissions = permissions
        .filter((eachUserPermission: IAuthUserPermission) => eachUserPermission.permission == EUserPermissions.PERMISSION_PERMISSIONS)
        .map((eachUserPermission: IAuthUserPermission) => ''+eachUserPermission.target_id);
      (Object.keys(this.permissionTargets) as any).forEach((eachIndex: number) => {
        if (
          isDeveloper ||
          PermissionHelper.hasPermission(this.authUser, EUserPermissions.PERMISSION_PERMISSIONS, 0) ||
          canGiveThesePermissions.includes(''+eachIndex)
        ) {
          ret.push({
            text: this.$t('settings.permissions.permissions.' + eachIndex + '.title'),
            value: eachIndex
          });
        }
      });
      return ret;
    }
    get targetItems() {
      let ret: any[] = [];
      let canBeGlobal = true;
      switch(this.permissionTargetClass(parseInt(this.data.permission))) {
        case EPermissionTargets.LOCKER_STATUS:
          ret.push({
            text: this.$t('lockers.locker.statuses.install'),
            description: this.$t('lockers.locker.statuses.install'),
            value: '1',
          });
          canBeGlobal = false;
        break;
        case EPermissionTargets.COMMUNITY:
          this.communities.forEach((eachCommunity: IShortCommunity) => ret.push({
            text: eachCommunity.name,
            description: eachCommunity.location_city,
            value: eachCommunity.id,
          }));
          canBeGlobal = false;
          break;
        // Should delete Locker Permission Target after the communityTarget is done in production
        case EPermissionTargets.LOCKER:
          this.lockers.forEach((eachLocker: ILocker) => ret.push({
            // id: eachLocker.id,
            text: eachLocker.name,
            value: eachLocker.id,
          }));
          break;
        case EPermissionTargets.SERVICE_PROVIDER:
          this.serviceProviders
              .filter((eachSp: IShortServiceProvider) => !eachSp.deleted_at)
              .forEach((eachSP: IShortServiceProvider) => ret.push({
                // id: eachSP.id,
                text: eachSP.name,
                description: eachSP.address_town_city,
                value: eachSP.id,
              }));
          break;
        // @todo implement these once we have a channelModule and spModule in store
        case EPermissionTargets.CHANNEL:
          this.channels
              // .filter()
              .forEach((eachChannel: IShortChannel) => ret.push({
                text: eachChannel.slug,
                description: eachChannel.name,
                value: eachChannel.id,
              }));
          canBeGlobal = false;
          break;
        case EPermissionTargets.USER_PERMISSION:
          Object.keys(this.$t('settings.permissions.permissions'))
              .forEach((eachPermissionId: any) => ret.push({
                // this ugly substr stuff will pad with leading spaces so sorting will sort by the number values actually
                text: ('     ' + eachPermissionId).substr(-5, 5) + ' - ' + this.$t('settings.permissions.permissions.' + eachPermissionId + '.title'),
                description: '',
                value: ('     ' + eachPermissionId).substr(-5, 5),
              }));

          canBeGlobal = true;
          break;
        default:
          break;
      }
      ret = this.orderTargetsById
        ? ret.sort((a: any, b: any) => a.id == b.id ? 0 : (a.id > b.id ? -1 : 1))
        : ret.sort((a: any, b: any) => a.text.localeCompare(b.text));
      if (canBeGlobal) {
        ret.unshift({
          text: this.$t('settings.permissions.global'),
          value: '0',
        });
      }
      return ret;
    }
    get targetLabel(): string {
      switch(this.permissionTargetClass(parseInt(this.data.permission))) {
        case EPermissionTargets.COMMUNITY:
          return this.$t('menu.communities.title') + ':';
        case EPermissionTargets.LOCKER:
          return this.$t('lockers.locker.title') + ':';
        case EPermissionTargets.LOCKER_STATUS:
          return this.$t('lockers.locker.statuses.title') + ':';
        case EPermissionTargets.SERVICE_PROVIDER:
          return this.$t('menu.providers.title') + ':';
        // @todo implement these once we have a channelModule and spModule in store
        case EPermissionTargets.CHANNEL:
          return this.$t('channels.title') + ':';
        case EPermissionTargets.USER_PERMISSION:
          return this.$t('settings.permissions.permissions.1.targetLabel') + ':';
        default:
          return '';
      }
    }

    showing: boolean = false;
    disabled: boolean = false;
    subscribes: IOnOffHandlers = {};
    data: {
      permission: string,
      target_id: string,
    } = {
      permission: "0",
      target_id: "0",
    };
    orderTargetsById: boolean = false;

    created() {
      this.subscribes = this.$ons({
        'up-dialog.show': this.onShow,
        'backend.call.begin.permissionsLoaded': this.onDisable,
        'backend.call.OK.permissionsLoaded': this.onHide,
        'backend.call.KO.permissionsLoaded': this.onError,
      });
      if (!this.communities || !this.communities.length) {
        this.$store.dispatch('communityModule/fetchAllCommunities');
      }
      if (!this.serviceProviders || !this.serviceProviders.length) {
        this.$store.dispatch('serviceProviderModule/fetchServiceProviders');
      }
      if (!this.channels || !this.channels.length) {
        this.$store.dispatch('channelModule/fetchChannels');
      }
      if (!this.permissionTargets || !this.permissionTargets.length) {
        this.$store.dispatch('permissionsModule/fetchPermissionTargets');
      }
    }
    beforeDestroy() {
      this.$offs(this.subscribes);
    }

    onSubmit() {
      this.$store.dispatch('userPermissionModule/createPermission', {
        userId: this.userId,
        permission: this.data.permission,
        target_id: this.data.target_id,
      });
    }
    onShow() {
      this.data.permission = '0';
      this.data.target_id = '0';
      this.disabled = false;
      this.showing = true;
    }
    onError() {
      this.disabled = false;
    }
    onHide() {
      this.showing = false;
    }
    onDisable() {
      this.disabled = true;
    }
    onEnable() {
      this.disabled = false;
    }
    onPermissionChange() {
      this.data.target_id = '0';
      this.$store.dispatch('userPermissionModule/cleanError', 'permission');
      this.$store.dispatch('userPermissionModule/cleanError', '_');
    }
    onTargetIdChange() {
      this.$store.dispatch('userPermissionModule/cleanError', 'target_id');
      this.$store.dispatch('userPermissionModule/cleanError', '_');
    }
    permissionTargetClass(currentPermission: number): string {
      return (this.permissionTargets[currentPermission] || '').replace(/^.*\\(.*)$/, "$1");
    }
    targetFilter(item: any, queryText: string): boolean {
      const name = (item.text || '').toLowerCase();
      const id = String(item.value || '');
      const query = queryText.toLowerCase();
      return name.indexOf(query) > -1 || id.indexOf(query) > -1;
    }
    showTargetItemChip(permissionTargetId: number) {
      const selectedPermission = this.data.permission;
      return (permissionTargetId > 0) && (selectedPermission != '1');
    }
  }

